import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { DASHBOARD_ICONS } from "../../../Helpers/ICONS";
import { TECHNICAL_COMMITTEE_ROUTES } from "../../../app/router/routes";
import LoaderComponent from "../../../components/Loader/LoaderComponent";
import NavBar from "../../../components/navbar/NavBar";
import { SectionColumn } from "../../../components/section";
import {
	STEPPER_STATUS,
	createStepper,
	disableAlert,
} from "../../../components/stepper/dynamicStepper";
import ProcessorStep1 from "../../processor/review/flow/ProcessorStep1";
import ProcessorStep4 from "../../processor/review/flow/ProcessorStep4";
import ProcessorStep5 from "../../processor/review/flow/ProcessorStep5";
import ProcessorStep6 from "../../processor/review/flow/ProcessorStep6";
import ProcessorStep7 from "../../processor/review/flow/ProcessorStep7";

export const stepperName = "FCView";

const TC_ProcessorView = () => {
	const stepper = [
		{
			step: "Business Details",
			status: STEPPER_STATUS.COMPLETED,
		},
		{
			step: "Source of Product",
			status: STEPPER_STATUS.COMPLETED,
		},

		{
			step: "Current Product Details",
			status: STEPPER_STATUS.COMPLETED,
		},

		{
			step: "Certificates",
			status: STEPPER_STATUS.COMPLETED,
		},
		{ step: "Other Documents", status: STEPPER_STATUS.COMPLETED },
	];
	const [stepperData, setStepperData] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setStepperData(createStepper(stepperName, stepper));
		disableAlert();
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	}, []);

	const routeArray = [
		TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP01,
		TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP02,
		TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP03,
		TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP04,
		TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP05,
	];
	return (
		<div>
			<LoaderComponent isOpen={isLoading} />
			<NavBar
				stepperName={stepperName}
				title={"Technical Committee Review"}
				tableIcon={DASHBOARD_ICONS.technicalCommittee}
				tableURL={TECHNICAL_COMMITTEE_ROUTES.REVIEW}
			/>

			{stepperData && (
				<SectionColumn className='w-full pt-1'>
					<Route path={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP01}>
						<ProcessorStep1
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={0}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP02}
							readOnly
							hideFiles={true}
						/>
					</Route>

					<Route path={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP02}>
						<ProcessorStep4
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={1}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP03}
							readOnly
						/>
					</Route>
					<Route path={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP03}>
						<ProcessorStep5
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={2}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP04}
							readOnly
						/>
					</Route>
					<Route path={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP04}>
						<ProcessorStep6
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={3}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP05}
							readOnly
						/>
					</Route>
					<Route path={TECHNICAL_COMMITTEE_ROUTES.PROCESSOR_STEP05}>
						<ProcessorStep7
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={4}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.REVIEW}
							readOnly
						/>
					</Route>
				</SectionColumn>
			)}
		</div>
	);
};

export default TC_ProcessorView;
